
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
name: 'user',
props: [],
components: {
XHeader,
Group,
XInput,
XButton
},
data () {
return {
titlepage: this.$route.meta.title
}
},
computed: {
title () {
return this.$route.meta.title
}
},
created () {},
mounted () {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/user/userItem/password.vue